import * as React from "react";
import { useHistory } from "react-router-dom";
import { URLS } from "@/utils/routes";
import { PROMPT_STUDIO_TABS, DesignStudioHeader } from "./DesignStudioHeader";

export type CoachDesignStudioTab = "designs" | "backgrounds";

const TAB_URLS: Record<CoachDesignStudioTab, string> = {
  designs: URLS.coach.designStudio,
  backgrounds: URLS.coach.designStudioBackgrounds,
};

interface CoachDesignStudioHeaderProps {
  tab: CoachDesignStudioTab;
  actions?: React.ReactNode;
}

/** The coach's Design Studio list header: ‹ Library │ Design Studio │ Designs · Backgrounds. */
export const CoachDesignStudioHeader: React.FC<CoachDesignStudioHeaderProps> = ({ tab, actions }) => {
  const history = useHistory();

  return (
    <DesignStudioHeader
      backTo={URLS.coach.prompts}
      backLabel="Library"
      tabs={PROMPT_STUDIO_TABS}
      selectedTab={tab}
      onTabChange={key => key !== tab && history.push(TAB_URLS[key as CoachDesignStudioTab])}
      actions={actions}
    >
      <div className="text-xl leading-7 font-bold text-slate-800">Design Studio</div>
    </DesignStudioHeader>
  );
};
